import { SimplePageLayout, SimplePageContentWrapper } from '@flexinet/ui-components';
import { TagsPageHeader } from '../components/PageHeaders';
import { TagsPageNavigation } from '../navigation/PageNavigations';
import { TagsTable } from '../tables/TagsTable';

export const TagsManagementPage = () => {
    return (
        <SimplePageLayout
            pageHeader={<TagsPageHeader />}
            pageNavigation={<TagsPageNavigation />}
        >
            <SimplePageContentWrapper>
                <TagsTable />
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
